import styled from 'styled-components';

import { applyColorFromProps } from 'packages/kakapo-ui-kit/helpers/Theme';

interface IHeadingProps {
	color?: string;
	isLight?: boolean;
}

export const PageTitle = styled.h2<IHeadingProps>`
	font-size: 23px;
	font-weight: 700;
	margin: 0;
	line-height: 1.25;
	color: ${(props) => applyColorFromProps(props, 'black')};
`;

export const PageTitleSub = styled.span<IHeadingProps>`
	font-size: 14px;
	font-weight: 400;
	color: ${(props) => applyColorFromProps(props, 'lightBlueDark')};
	margin: 0;
`;

export const PageTitleSubLarge = styled.span<IHeadingProps>`
	font-size: 16px;
	font-weight: 400;
	color: ${(props) => applyColorFromProps(props, 'lightBlueDark')};
	margin: 0;
`;

export const SectionTitle = styled.h3<IHeadingProps>`
	font-size: 18px;
	color: ${(props) => applyColorFromProps(props, 'slateBlue')};
	margin: 0;
	${(props) =>
		props.onClick
			? `
		cursor: pointer;
		user-select: none;
	`
			: ''};
`;

export const SubSectionTitle = styled.h4<IHeadingProps>`
	font-size: 16px;
	color: ${(props) => applyColorFromProps(props, 'slateBlue')};
	margin: 0;
	${(props) => (props.onClick ? 'cursor: pointer;' : '')};
	color: ${(props) => (props.isLight ? applyColorFromProps(props, 'lightBlueDark') : '')};
`;
